import {useSelector} from 'src/v2/state/store';

export const useIsAnyCryptoWalletConnectFlow = () =>
  useSelector(
    (state) =>
      state.featureFlags.enable_pay_with_any_crypto_wallet_connect &&
      state.walletConnectSupportedCurrencies.some(
        (c) => c.assetCode === state.anyCryptoDeposit.selectedToken,
      ),
  );
